import { AgError } from '@australiangreens/ag-error';
import { Button, ButtonProps } from '@mui/material';
import React, { useState } from 'react';
import { ApiError } from '@/errors/ApiError';

const invalidJson = '{hello';

type FakeErrorButtonProps = {
  technique: string;
  children: React.ReactNode;
} & ButtonProps;

const FakeErrorButton = ({
  children,
  technique = 'SyntaxError',
  ...rest
}: FakeErrorButtonProps) => {
  const [throwAnError, setThrowAnError] = useState(false);

  if (throwAnError) {
    switch (technique) {
      case 'SyntaxError':
        return JSON.parse(invalidJson);
      case 'Error':
        throw new AgError(
          'This is a fake error triggered by pressing the fake error button with a bomb on it!'
        );
      case 'ApiError':
        throw new ApiError(
          'This is a fake error triggered by pressing the fake error button with a bomb on it!'
        );
      default:
        throw new AgError('undefined');
    }
  }

  return (
    <Button
      sx={{ textAlign: 'left' }}
      color="warning"
      variant="contained"
      size="small"
      onClick={() => setThrowAnError(true)}
      {...rest}
    >
      {children}
    </Button>
  );
};

export default FakeErrorButton;
